import { render, staticRenderFns } from "./genderCategory.vue?vue&type=template&id=0ab1454c&"
import script from "./genderCategory.vue?vue&type=script&lang=js&"
export * from "./genderCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports